import { render } from "./VerifyEmailPage.vue?vue&type=template&id=32425e86"
import script from "./VerifyEmailPage.vue?vue&type=script&lang=js"
export * from "./VerifyEmailPage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__